/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OtherFile/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import ButtonGrey from 'DesignSystem/ButtonGrey/index'
import Info from 'DesignSystem/Info/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function OtherFile({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Content/Content/Content/Actions/Upload/Content/Documents/Content/SystemFiles/Preview/Content/PreviewSection/OtherFile"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="OtherFile.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text="No preview available for the selected file"
/>
<ButtonGrey
  viewPath={`${viewPath}/ButtonGrey`}
 marginTop={16}
 text="Open in new tab"
 onClick={onClick}
/>
</div>
{children}
</React.Fragment>)
}